import _ from 'lodash'
import { Module } from 'vuex'

import { RootState } from '../../types'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { initialUserState, UserState,  } from './types'

export const user: Module<UserState, RootState> =  {
  namespaced: true,
  state: _.cloneDeep(initialUserState),
  actions,
  getters,
  mutations,
}
